<div class="relative flex flex-col h-full min-h-0">
  <div
    #scroll
    cdkScrollable
    class="flex-1 min-h-0 overflow-y-auto overscroll-contain px-2 mobile:px-3 py-2"
    role="log"
    [attr.aria-label]="'DISCUSSION.MESSAGES' | translate"
    aria-live="polite"
    (scroll)="onScroll()"
  >
    <div #content>
      <div [hidden]="hasMore">
        @if (originDate) {
        <p
          class="!my-2 text-center uppercase tracking-wide text-sm font-bold text-grey dark:text-lightGrey"
        >
          {{ dateLabel(originDate) }}
        </p>
        }
        <ng-content select="[discussionOrigin]"></ng-content>
      </div>
      @if (hasMore) {<button
        type="button"
        class="block mx-auto my-2 text-sm underline"
        [disabled]="loadingMore"
        (click)="older()"
      >
        {{
          (loadingMore ? "DISCUSSIONS.LOADING" : "DISCUSSION.OLDER") | translate
        }}</button
      >} @for (entry of timeline; track entry._id; let index = $index) { @if
      (newDay(index)) {
      <p
        class="!my-2 text-center uppercase tracking-wide text-sm font-bold text-grey dark:text-lightGrey"
      >
        {{ dateLabel(entry.createdAt) }}
      </p>
      } @if (firstUnread(index)) {
      <div
        data-first-unread
        class="flex items-center gap-1 text-primary-text dark:text-primary text-xs font-bold my-3"
      >
        <span class="h-px bg-primary/40 flex-1"></span
        >{{ "DISCUSSION.NEW" | translate
        }}<span class="h-px bg-primary/40 flex-1"></span>
      </div>
      }
      <app-discussion-message
        [attr.data-discussion-anchor]="entry._id"
        [entry]="entry"
        [author]="author(entry.authorId)"
        [own]="entry.authorId === userId"
        [authorOnline]="friendOnline"
        [seen]="entry.authorId === userId && entry.sequence <= peerReadSequence"
        [deleting]="deleting"
        [workType]="workType"
        [canReact]="canReply"
        [participants]="participants"
        [userId]="userId"
        (remove)="removeMessage.emit($event)"
        (report)="reportMessage.emit($event)"
        (openWork)="openWork.emit($event)"
      ></app-discussion-message>
      }
    </div>
  </div>
  @if (newMessages) {
  <button
    type="button"
    class="shrink-0 self-center rounded-full bg-primary text-black px-2 py-1 shadow-md"
    (click)="bottom()"
  >
    {{
      (newMessages === 1 ? "DISCUSSIONS.NEW_ONE" : "DISCUSSIONS.NEW_MANY")
        | translate: {count: newMessages}
    }}
    ↓
  </button>
  }
  <div
    class="h-[32px] shrink-0 px-2 mobile:px-3 flex items-center"
    role="status"
    aria-live="polite"
    aria-atomic="true"
  >
    <span
      class="flex items-center gap-[4px] rounded-full bg-whiteshade dark:bg-black-dark-lighter px-[12px] py-[8px] text-grey dark:text-lightGrey transition-opacity duration-150 motion-reduce:transition-none"
      [class.opacity-0]="!typingVisible || !canReply"
      [attr.aria-hidden]="!typingVisible || !canReply"
    >
      @if (typingVisible && canReply) {
      <span class="sr-only">{{
        "DISCUSSION.TYPING"
          | translate
            : {name: recipient || ("DISCUSSION.DELETED_USER" | translate)}
      }}</span>
      } @for (delay of [0, 150, 300]; track delay) {
      <span
        aria-hidden="true"
        class="block w-[5px] h-[5px] rounded-full bg-current motion-reduce:animate-none"
        [class]="typingVisible && canReply ? 'motion-safe:animate-bounce' : ''"
        [style.animation-delay.ms]="delay"
      ></span>
      }
    </span>
  </div>
  <app-discussion-composer
    class="shrink-0 pb-[var(--sab)]"
    [recipient]="recipient"
    [suggestions]="suggestions"
    [disabled]="!canReply"
    [readOnlyReason]="readOnlyReason"
    [sending]="sending"
    [sentRevision]="sentRevision"
    (sendMessage)="sendMessage.emit($event)"
    (typing)="typing.emit($event)"
  ></app-discussion-composer>
</div>
